/**
 * Scroll progress bar: fills as the user scrolls the page.
 * Runs when .e-stn--banner-with-progressbar or .e-stn--demo-detail-banner is present.
 * Creates .e-div--scroll-progress and .e-div--scroll-progress-fill in JS if not in HTML.
 * Fixed bar top offset matches #wpadminbar height when the admin toolbar is shown.
 */
( function () {
  const SECTION_SELECTORS = '.e-stn--banner-with-progressbar, .e-stn--demo-detail-banner';
  const BIND_SECTION_SELECTOR = '.e-stn--progress-bind-section';
  const BAR_WRAPPER_CLASS = 'e-div--scroll-progress';
  const BAR_FILL_CLASS = 'e-div--scroll-progress-fill';

  function getSection() {
    return document.querySelector( SECTION_SELECTORS );
  }

  function getBindSection() {
    return document.querySelector( BIND_SECTION_SELECTOR );
  }

  function getAdminBarHeight() {
    const adminBar = document.getElementById( 'wpadminbar' );
    return adminBar ? adminBar.offsetHeight : 0;
  }

  function setProgressBarTop( wrapper ) {
    if ( !wrapper ) return;
    wrapper.style.top = getAdminBarHeight() + 'px';
  }

  function createProgressBarElements( section ) {
    const wrapper = document.createElement( 'div' );
    wrapper.className = BAR_WRAPPER_CLASS;
    const fill = document.createElement( 'div' );
    fill.className = BAR_FILL_CLASS;
    wrapper.appendChild( fill );
    section.insertBefore( wrapper, section.firstChild );
    return wrapper;
  }

  function getOrCreateProgressBar( section ) {
    let wrapper = section.querySelector( '.' + BAR_WRAPPER_CLASS );
    if ( !wrapper ) {
      wrapper = createProgressBarElements( section );
    }
    const fill = wrapper.querySelector( '.' + BAR_FILL_CLASS );
    return fill ? { wrapper, fill } : null;
  }

  function getDocumentScrollPercentage() {
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if ( docHeight <= 0 ) return 0;
    const scrolled = window.scrollY;
    return Math.min( 100, Math.max( 0, ( scrolled / docHeight ) * 100 ) );
  }

  function getBoundSectionScrollPercentage( bindSection ) {
    const viewportHeight = window.innerHeight;
    const rect = bindSection.getBoundingClientRect();
    const sectionTop = window.scrollY + rect.top;
    const sectionHeight = bindSection.offsetHeight;

    if ( sectionHeight <= 0 ) return 0;

    const triggerStart = sectionTop - viewportHeight / 2;
    const sectionEnd = sectionTop + sectionHeight;
    const scrolled = window.scrollY;

    if ( scrolled <= triggerStart ) return 0;
    if ( scrolled >= sectionEnd ) return 100;

    const progress = ( scrolled - triggerStart ) / ( sectionEnd - triggerStart );
    return Math.min( 100, Math.max( 0, progress * 100 ) );
  }

  function getScrollPercentage( bindSection ) {
    if ( !bindSection ) {
      return getDocumentScrollPercentage();
    }
    return getBoundSectionScrollPercentage( bindSection );
  }

  function updateProgressBar( bar, bindSection ) {
    const percentage = getScrollPercentage( bindSection );
    bar?.fill?.style && ( bar.fill.style.width = percentage + '%' );

    const isActive = percentage > 0;
    if ( bar?.wrapper?.style ) {
      bar.wrapper.style.opacity = isActive ? '1' : '0';
      bar.wrapper.style.pointerEvents = isActive ? 'auto' : 'none';
    }
  }

  function createThrottledScrollHandler( bar, bindSection ) {
    let ticking = false;
    return function () {
      if ( ticking ) return;
      ticking = true;
      requestAnimationFrame( function () {
        setProgressBarTop( bar.wrapper );
        updateProgressBar( bar, bindSection );
        ticking = false;
      } );
    };
  }

  function attachScrollAndResizeListeners( bar, bindSection ) {
    const handler = createThrottledScrollHandler( bar, bindSection );
    window.addEventListener( 'scroll', handler, { passive: true } );
    window.addEventListener( 'resize', handler );
  }

  function init() {
    const section = getSection();
    if ( !section ) return;

    const bindSection = getBindSection();

    const bar = getOrCreateProgressBar( section );
    if ( !bar ) return;

    setProgressBarTop( bar.wrapper );
    updateProgressBar( bar, bindSection );
    attachScrollAndResizeListeners( bar, bindSection );
  }

  function runWhenReady() {
    if ( document.readyState === 'loading' ) {
      document.addEventListener( 'DOMContentLoaded', init );
      return;
    }
    init();
  }

  runWhenReady();
} )();
